/* =========================================================
   MADSPEED7 — EMAIL THIS PRODUCT
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.querySelector('[data-ms7-email-product]');
  const popup = document.getElementById('ms7-email-product-popup');

  if (!openButton || !popup) return;

  const closeButtons = popup.querySelectorAll('[data-ms7-email-close]');
  const emailInput = document.getElementById('MS7EmailProduct-email');
  const submitButton = popup.querySelector('.ms7-email-product-form__submit');
  const form = popup.querySelector('.ms7-email-product-form');
  const intro = popup.querySelector('.ms7-email-product-popup__intro');

    /*
   * WHEELHUT — SiteGround PHP endpoint.
   */
  const emailEndpoint =
    'https://wheelbox.co.uk/shopify-cron/wheelhut-email-product.php';

  /*
   * Get the current product information.
   */
  function getProductName() {
    const ogTitle = document.querySelector(
      'meta[property="og:title"]'
    );

    if (ogTitle && ogTitle.content) {
      return ogTitle.content.trim();
    }

    return document.title
      .replace(/\s*[|–-]\s*MADSPEED7.*$/i, '')
      .trim();
  }

  function getProductUrl() {
    const canonical = document.querySelector(
      'link[rel="canonical"]'
    );

    if (canonical && canonical.href) {
      return canonical.href;
    }

    return window.location.href;
  }

  /*
   * Get the product image.
   */
  function getProductImage() {
    const ogImage = document.querySelector(
      'meta[property="og:image"]'
    );

    if (ogImage && ogImage.content) {
      return ogImage.content.trim();
    }

    return '';
  }

  /*
   * Get the currently displayed product price.
   */
  function getProductPrice() {

    const salePrice = document.querySelector(
      '.price-item--sale'
    );

    if (
      salePrice &&
      salePrice.offsetParent !== null &&
      salePrice.textContent.trim()
    ) {
      return salePrice.textContent.trim();
    }

    const regularPrice = document.querySelector(
      '.price-item--regular'
    );

    if (
      regularPrice &&
      regularPrice.offsetParent !== null &&
      regularPrice.textContent.trim()
    ) {
      return regularPrice.textContent.trim();
    }

    const lastPrice = document.querySelector(
      '.price-item--last'
    );

    if (
      lastPrice &&
      lastPrice.offsetParent !== null &&
      lastPrice.textContent.trim()
    ) {
      return lastPrice.textContent.trim();
    }

    return '';
  }

  /*
   * Open popup.
   */
  function openPopup() {
    popup.style.display = 'block';
    popup.setAttribute('aria-hidden', 'false');


  }

  /*
   * Close popup.
   */
  function closePopup() {
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
  }

  /*
   * Open button.
   */
  openButton.addEventListener('click', openPopup);

  /*
   * Close buttons.
   */
  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  /*
   * Escape key.
   */
  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      popup.getAttribute('aria-hidden') === 'false'
    ) {
      closePopup();
    }
  });

  /*
   * SEND button.
   */
  if (submitButton) {
    submitButton.addEventListener('click', async function () {

      const email = emailInput
        ? emailInput.value.trim()
        : '';

      /*
       * Basic browser validation.
       */
      if (!emailInput || !emailInput.checkValidity()) {
        if (emailInput) {
          emailInput.reportValidity();
        }

        return;
      }

      /*
       * Prevent double-clicking.
       */
      submitButton.disabled = true;
      submitButton.textContent = 'SENDING...';

      try {

        const response = await fetch(emailEndpoint, {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            email: email,
            product_name: getProductName(),
            product_url: getProductUrl(),
            product_image: getProductImage(),
            product_price: getProductPrice()
          })
        });

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(
            result.message || 'Unable to send the email.'
          );
        }

        /*
         * Successful email.
         */
        if (form) {
          form.style.display = 'none';
        }

        if (intro) {
          intro.textContent =
            'The product link has been sent to your email address.';
        }

        /*
         * Change the heading.
         */
        const title = document.getElementById(
          'ms7-email-product-title'
        );

        if (title) {
          title.textContent = 'EMAIL SENT';
        }

      } catch (error) {

        console.error(
          'MADSPEED7 product email error:',
          error
        );

        submitButton.disabled = false;
        submitButton.textContent = 'SEND';

        alert(
          'Technical error: ' + error.message
        );
      }
    });
  }
});